// extracted by mini-css-extract-plugin
module.exports = {"auth":"index_auth_pqM0A","container":"index_container_1D-HS","googleSign":"index_googleSign_3Yc10","footerNav":"index_footerNav_3jvun"};